import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { SvgIcon } from '../svg-icon.js'

import styles from './single-bolt-pin-icon.module.css'

const foregroundPath = `M37.8,7.89c-.06-.06-.13-.13-.19-.19C30.07,.24,17.93,.24,10.39,7.7c-7.47,7.37-7.56,19.4-.19,26.87,.06,.06,.13,.13,.19,.19,3.49,3.46,13.61,11.34,13.61,11.34,0,0,10.13-7.88,13.61-11.34,7.47-7.37,7.56-19.4,.19-26.87Zm-1.1,26.01c-3.25,3.2-12.7,10.58-12.7,10.58,0,0-9.45-7.38-12.7-10.58-6.97-6.98-6.96-18.29,.02-25.26,3.36-3.36,7.93-5.24,12.68-5.22,9.89-.05,17.95,7.93,18,17.82,0,.01,0,.02,0,.03,0,4.75-1.91,9.3-5.3,12.63Zm-6.91-14.25c.1,.19,.1,.41,0,.58l-6.89,11.67c-.11,.19-.3,.29-.5,.29-.06,0-.13-.01-.19-.04-.26-.09-.42-.35-.39-.63l.96-7.5h-4c-.21,0-.41-.12-.5-.29-.1-.19-.1-.41,0-.58l6.89-11.67c.14-.23,.43-.34,.69-.26,.26,.09,.42,.35,.39,.63l-.96,7.5h4c.21,0,.4,.12,.5,.29Z`

const backgroundPath = `M36.83,8.79s-.09-.09-.13-.13c-7.02-6.99-18.38-6.99-25.4,0-6.97,6.9-7.03,18.14-.13,25.12,.04,.04,.09,.09,.13,.13,3.25,3.21,12.7,10.59,12.7,10.59,0,0,9.45-7.38,12.7-10.58,6.98-6.9,7.03-18.15,.13-25.13Z`

const propTypes = {
    backgroundClassName: PropTypes.string,
    backgroundStyle: PropTypes.objectOf(PropTypes.string),
    foregroundClassName: PropTypes.string,
    foregroundStyle: PropTypes.objectOf(PropTypes.string),
    mainClassName: PropTypes.string
}

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function returning SVG icon with single bolt placed in the pin shape.
 * <SingleBoltIcon> contains same icon without pin frame
 *
 * @function
 * @param {Object} [props] The component properties
 * @param {string} [props.backgroundClassName] - The class name for the background svg path
 * @param {Object} [props.backgroundStyle] - The style object for the background svg path
 * @param {string} [props.foregroundClassName] - The class name for the foreground svg path
 * @param {Object} [props.foregroundStyle] - The style object for the foreground svg path
 * @param {string} [props.mainClassName] - The main class name for the pin icon
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <SingleBoltPinIcon
 *     width={12}
 *     mainClassName={cx(styles['any-class'], 't3sel-some-selector')}
 *     backgroundClassName={styles['any-other-class']} />
 */
const SingleBoltPinIcon = function (props) {
    const { backgroundClassName, backgroundStyle, foregroundClassName, foregroundStyle, mainClassName } = props

    return (
        <SvgIcon {...props} className={cx(mainClassName, styles['single-bolt-pin'])}>
            <path
                className={cx(styles['single-bolt-pin-background'], backgroundClassName)}
                style={backgroundStyle}
                d={backgroundPath}
            />
            <path
                className={cx(styles['single-bolt-pin-foreground'], foregroundClassName)}
                style={foregroundStyle}
                d={foregroundPath}
            />
        </SvgIcon>
    )
}

SingleBoltPinIcon.defaultProps = defaultProps
SingleBoltPinIcon.propTypes = propTypes

export { SingleBoltPinIcon }
